module.exports = __webpack_public_path__ + "img/074.ce68bac4.png";